// @ts-nocheck
import React, { useState } from "react";
import {
  RUTA_API_ALIAS,
  RUTA_API_AREAS,
  URL_API_SIA,
} from "../../Contantes/Constantes";
import { AreasContext } from "./AreasContext";
import { useBody } from "../../Body/state/BodyContext";
import axios from "axios";
import { setupInterceptorsTo } from "../../Componentes/API/AxiosBuilder";
import KeyCloak from "../../Auth/Keycloak";
import { useAuth } from "../../Auth/State/AuthContext";

export function ProvideAreas({ children }) {
  const emails = useProvideAreas();
  return (
    <AreasContext.Provider value={emails}>{children}</AreasContext.Provider>
  );
}

function useProvideAreas() {
  const { setMessage } = useBody();
  const [areas, setAreas] = useState([]);
  const [area, setArea] = useState({
    path: "",
    nombre: "",
    integrantes: [],
    observaciones: "",
    oficinas: [],
    internos: [],
    noReply: [],
  });
  const [areasTree, setAreasTree] = useState([]);
  const [areasTreeFlatList, setAreasTreeFlatList] = useState([]);
  const [areaData, setAreaData] = useState({
    nombre: "",
    path: "",
    integrantes: [],
    alias: [],
    observaciones: "",
    oficinas: [],
    internos: [],
    noReply: [],
  });
  const [value, setValue] = useState({
    path: "",
    nombre: "",
    integrantes: [],
    observaciones: "",
    oficinas: [],
    internos: [],
    noReply: [],
  });

  const [areaSub, setAreaSub] = useState([]);
  const [loading, setLoading] = useState(true);
  const axiosInstance = setupInterceptorsTo(axios.create());
  const [integrantes, setIntegrantes] = useState("");
  const [oficina, setOficina] = useState("");
  const [numero, setNumero] = useState("");
  const [especificacion, setEspecificacion] = useState("");
  const [alertOficina, setAlertOficina] = useState(null);
  const [alertInterno, setAlertInterno] = useState(null);
  const { user } = useAuth();

  const inte = (response) => {
    if (response.data.integrantes.length === 0) return [];
    else return response.data.integrantes;
  };
  const alia = (response) => {
    if (response.data.alias.length === 0) return [];
    else return response.data.alias;
  };
  const inter = (response) => {
    return response.map((i) => {
      //i= "numero:123;especificacion:example";
      const numeroInicio = i.indexOf(":") + 1;
      const numeroFin = i.indexOf(";");
      const numero = parseInt(i.substring(numeroInicio, numeroFin));

      const especificacionInicio = i.lastIndexOf(":") + 1;
      const especificacion = i.substring(especificacionInicio);

      return {
        numero: numero,
        especificacion: especificacion,
      };
    });
  };
  async function fetchArea(grupo) {
    await axiosInstance({
      method: "GET",
      url: URL_API_SIA + "/areas/area/" + grupo.id,
    })
      .then((response) => {
        let are = {
          path: obtenerPath(response.data.path, response.data.nombre),
          nombre: response.data.nombre,
          integrantes:
            response.data.integrantes.length !== 0
              ? response.data.integrantes.map(
                (integrante) => integrante.username
              )
              : [],
          observaciones:
            response.data.observacion.length !== 0
              ? response.data.observacion[0]
              : "",
          internos:
            response.data.internos.length > 0
              ? inter(response.data.internos)
              : [],
          oficinas:
            response.data.oficinas.length > 0 ? response.data.oficinas : [],
          noReply: response.data.noReply ?? [],
        };
        let area = {
          path: obtenerPath(response.data.path, response.data.nombre),
          nombre: response.data.nombre,
          integrantes: response.data.integrantes,
          observaciones:
            response.data.observacion.length !== 0
              ? response.data.observacion[0]
              : "",
          internos:
            response.data.internos.length > 0
              ? inter(response.data.internos)
              : [],
          oficinas:
            response.data.oficinas.length > 0 ? response.data.oficinas : [],
          noReply: response.data.noReply ?? [],
        };
        setAreaData((prevProfile) => ({
          ...prevProfile,
          nombre: are.nombre,
          path: are.path,
          integrantes:
            response.data.integrantes.length !== 0
              ? response.data.integrantes
              : [],
          alias: response.data.alias.length !== 0 ? response.data.alias : [],
          observaciones: are.observaciones,
          internos: are.internos,
          oficinas: are.oficinas,
          noReply: are.noReply,
        }));
        setValue(are);
        setArea(area);
      })
      .catch((e) => {
        setMessage("Hubo un error al traer el area (Código de error : 00034)");
      });
  }

  async function getArea(areaId) {
    try {
      const response = await axiosInstance({
        method: "GET",
        url: URL_API_SIA + "/areas/area/" + areaId,
      });
      return response.data;
    } catch (e) {
      setMessage("Hubo un error al querer obtener el area");
      console.error("Hubo un error al querer obtener el area: ", e);
    }
  }

  async function getAreaNamesByIds(ids) {
    try {
      const response = await axiosInstance.post(URL_API_SIA + '/areas/areasByIds/nombres', { ids });
      return response.data;
    } catch (e) {
      console.error("Error al traer nombres de áreas:", e);
      return [];
    }
  }

  async function getAreasWithAlias(ids) {
    try {
      const response = await axiosInstance.post(
        URL_API_SIA + "/areas/areasByIds",
        { ids }
      );
      return response.data;
    } catch (e) {
      setMessage("Hubo un error al querer obtener las areas con sus alias");
      console.error("Hubo un error al querer obtener las areas con sus alias: ", e);
    }
  }

  async function fetchSubgrupos(grupo) {
    try {
      const response = await axiosInstance({
        method: "GET",
        url: `${URL_API_SIA}/areas/area/subgrupos/${grupo.id}`,
      });
      setAreaSub(response.data);
      setLoading(false);
      return response.data;
    } catch (e) {
      setMessage(
        "Hubo un error al traer los subgrupos (Código de error : 00035)"
      );
      console.error("Error obteniendo subgrupos:", e);
      return [];
    }
  }

  const getAreas = async () => {
    try {
      const response = await axiosInstance({
        method: "GET",
        url: URL_API_SIA + "/areas/areas",
      });
      setAreas(response.data);
      return response.data;
    } catch (e) {
      console.error("Error al traer las áreas:", e);
      setMessage("Hubo un error al traer las áreas (Código de error: 00033)");
    }
  };

  const getUserAreas = async () => {
    try {
      const response = await axiosInstance({
        method: "GET",
        url: URL_API_SIA + "/areas/usuarios/" + Number(user.uidnumber) + "/areas",
      });

      return response.data;
    } catch (e) {
      console.error("Error al traer las áreas de un usuario:", e);
      setMessage(
        "Hubo un error al traer las áreas de un usuario (Código de error: 00033)"
      );
    }
  };

  const getAreasTree = async (flat = false) => {

    const areasTreeFlatList = [];

    try {
      const areas = await getAreas();

      const fetchAllSubgrupos = async (grupo) => {
        areasTreeFlatList.push(grupo);
        if (grupo.subGroupCount > 0) {
          const subgrupos = await fetchSubgrupos(grupo);
          for (const subgrupo of subgrupos) {
            subgrupo.subGroups = await fetchAllSubgrupos(subgrupo);
          }
          return subgrupos;
        } else {
          return [];
        }
      };

      const areasTree = await Promise.all(
        areas.map(async (a) => {
          a.subGroups = await fetchAllSubgrupos(a);
          return a;
        })
      );

      setAreasTree(areasTree);
      setAreasTreeFlatList(areasTreeFlatList);
      if (flat) {
        return areasTreeFlatList; // Para algunos componentes esto es útil
      } else {
        return areasTree;  // Para algunos componentes esto es útil
      }
    } catch (e) {
      console.error("Error al construir el árbol de áreas:", e);
      setMessage(
        "Hubo un error al construir el árbol de áreas (Código de error: 00036)"
      );
      return [];
    }
  };

  const getAreasFlatTree = async () => {
    const areasTreeFlatList = [];

    try {
      const areas = await getAreas();

      const fetchAllSubgrupos = async (grupo) => {
        areasTreeFlatList.push(grupo);
        if (grupo.subGroupCount > 0) {
          const subgrupos = await fetchSubgrupos(grupo);
          for (const subgrupo of subgrupos) {
            subgrupo.subGroups = await fetchAllSubgrupos(subgrupo);
          }
          return subgrupos;
        } else {
          return [];
        }
      };

      const areasTree = await Promise.all(
        areas.map(async (a) => {
          a.subGroups = await fetchAllSubgrupos(a);
          return a;
        })
      );

      setAreasTree(areasTree);
      setAreasTreeFlatList(areasTreeFlatList);
      return areasTreeFlatList; // Para algunos componentes esto es útil
    } catch (e) {
      console.error("Error al construir el árbol de áreas:", e);
      setMessage(
        "Hubo un error al construir el árbol de áreas (Código de error: 00036)"
      );
      return [];
    }
  };

  const obtenerPath = (path, nombre) => {
    let r;
    if (path.split("/").filter((p) => p !== "").length <= 1) {
      r = path.replace(nombre, "");
    } else {
      r = path.replace("/" + nombre, "");
    }
    return r;
  };

  // EDITAR Y AGREGAR AREAS , INPUTS DE INTEGRANTES, INTERNOS Y OFICINAS

  const handleChangeI = () => (event) => {
    setIntegrantes(event.target.value);
  };

  const handleChangeO = () => (event) => {
    setOficina(event.target.value);
  };

  const handleChangeTN = () => (event) => {
    setNumero(event.target.value);
  };
  const handleChangeTD = () => (event) => {
    setEspecificacion(event.target.value);
  };

  function handleClickAddIntegrante() {
    if (integrantes !== "") {
      const aux = area.integrantes || [];
      aux.push({
        id: "",
        username: integrantes,
        nombre_completo: "",
        mail: integrantes + "@frba.utn.edu.ar",
      });
      setArea({
        ...area,
        integrantes: aux,
      });
      setIntegrantes("");
    } else {
      setAlertOficina({
        status: "error",
        message: "El uid debe tener entre 3 y 70 caracteres",
      });
    }
  }
  function handleClickRemoveIntegrante(item) {
    const aux = area.integrantes.filter((i) => i.username !== item);
    setArea({
      ...area,
      integrantes: aux,
    });
  }
  function handleClickAddOficina() {
    const regex = /[0-9]{1,4}/;
    if (!regex.test(oficina)) {
      setAlertOficina({
        status: "error",
        message: "La oficina debe ser un numero de entre 1 y 4 digitos",
      });
    } else if (oficina.length <= 4 && oficina !== "") {
      const aux = area.oficinas;
      aux.push(oficina);
      setArea({
        ...area,
        oficinas: aux,
      });
      setOficina("");
    } else {
      setAlertOficina({
        status: "error",
        message: "La oficina debe ser un numero de entre 1 y 4 digitos",
      });
    }
  }

  function handleClickRemoveOficina(item) {
    const aux = area.oficinas.filter((i) => {
      return i !== item;
    });
    setArea({
      ...area,
      oficinas: aux,
    });
  }
  function handleClickAddInterno() {
    const regex = /[0-9]{1,5}/;
    if (especificacion !== "" && numero === "") {
      setAlertInterno({
        status: "error",
        message: "Debe agregar un numero de interno",
      });
    } else if (numero !== "" && numero.length > 5) {
      setAlertInterno({
        status: "error",
        message:
          "Los numeros del interno debe ser un numero de entre 1 y 5 digitos.",
      });
    } else if (
      especificacion !== "" &&
      3 > especificacion.length &&
      especificacion.length > 20
    ) {
      setAlertInterno({
        status: "error",
        message:
          "Las especificaciones del interno deben tener entre 3 y 20 caracteres.",
      });
    } else if (!regex.test(numero)) {
      setAlertInterno({
        status: "error",
        message:
          "Los numeros del interno debe ser un numero de entre 1 y 5 digitos.",
      });
    } else if (numero !== "") {
      const aux = area.internos;
      aux.push({ numero: numero, especificacion: especificacion });
      setArea({
        ...area,
        internos: aux,
      });
      setNumero("");
      setEspecificacion("");
    }
  }

  function handleClickRemoveInterno(item) {
    const aux = area.internos.filter((i) => {
      if (i.especificacion === "") return i.numero !== item.numero;
      else
        return (
          i.numero !== item.numero && i.especificacion !== item.especificacion
        );
    });
    setArea({
      ...area,
      internos: aux,
    });
  }

  return {
    fetchArea,
    fetchSubgrupos,
    getArea,
    getAreasTree,
    getUserAreas,
    areasTree,
    areasTreeFlatList,
    setAreasTreeFlatList,
    areas,
    setAreas,
    getAreas,
    area,
    setArea,
    areaData,
    setAreaData,
    areaSub,
    setAreaSub,
    loading,
    setLoading,
    getAreaNamesByIds,
    getAreasWithAlias,
    value,
    setValue,
    handleChangeI,
    handleChangeO,
    handleChangeTN,
    handleChangeTD,
    handleClickRemoveIntegrante,
    handleClickAddIntegrante,
    handleClickRemoveOficina,
    handleClickAddOficina,
    handleClickRemoveInterno,
    handleClickAddInterno,
    integrantes,
    setIntegrantes,
    oficina,
    setOficina,
    numero,
    setNumero,
    especificacion,
    setEspecificacion,
    alertOficina,
    setAlertOficina,
    alertInterno,
    setAlertInterno,
    getAreasFlatTree
  };
}
